<template>
  <el-form-item
    :label="formItem.label"
    :required="
      formItem.type === 'datepicker' &&
      (taskName === '退款-审核列表' || taskName === '商品抵扣列表')
    "
  >
    <el-input
      v-if="formItem.type === 'input'"
      v-model="filter.value"
      style="width: 200px"
      size="mini"
      placeholder="请输入"
      @input="input"
    ></el-input>
    <el-select
      v-if="formItem.type === 'select'"
      v-model="filter.value"
      size="mini"
      :multiple="!!formItem.multiple"
      clearable
      @change="input"
    >
      <el-option
        v-for="option in formItem.field"
        :key="option.value"
        :label="option.label"
        :value="option.value"
        @input="input"
      ></el-option>
    </el-select>
    <div v-if="formItem.type === 'datepicker'">
      <el-select
        v-model="filter.value.field"
        size="mini"
        value-key="value"
        clearable
        @change="handleSelect"
      >
        <el-option
          v-for="option in formItem.field"
          :key="option.value"
          :label="option.label"
          :value="option"
        ></el-option>
      </el-select>
      <el-date-picker
        ref="time"
        v-model="filter.value.value"
        size="mini"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @input="datepickerInput"
      >
      </el-date-picker>
    </div>
  </el-form-item>
</template>
<script>
export default {
  name: "OperateTaskFormItem",
  props: {
    formItem: {
      type: Object,
      default: () => {},
    },
    taskName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filter: {
        type: this.formItem.type,
        name: this.formItem.name,
        as: typeof this.formItem.as !== "undefined" ? this.formItem.as : "",
        value: null,
      },
    };
  },
  watch: {
    formItem() {
      console.log("watch form item", this.formItem);
      this.filter.type = this.formItem.type;
      this.filter.name = this.formItem.name;
      this.filter.as =
        typeof this.formItem.as !== "undefined" ? this.formItem.as : "";

      if (this.formItem.type === "datepicker") {
        this.filter.value = {
          field: null,
          value: [],
        };
      } else {
        this.filter.value = null;
      }
    },
  },
  created() {
    if (this.formItem.type === "datepicker") {
      this.filter.value = {};
    } else {
      this.filter.value = null;
    }
  },
  methods: {
    input(e) {
      console.log("emit consile", e);
      const data = {
        type: this.filter.type,
        name: this.filter.name,
        field: this.filter.name,
        as: this.filter.as,
        value: e,
      };
      this.$emit("change", data);
    },
    handleSelect(select) {
      this.filter.as = typeof select.as !== "undefined" ? select.as : "";
      if (this.filter.value.value) {
        this.filter.value.value = null;
        this.datepickerInput(this.$refs.time);
      }
    },
    datepickerInput(e) {
      if (typeof this.filter.value.field === "undefined") {
        this.filter.value.value = null;
        this.$message.e("请先选择时间字段");
        return;
      }
      // 是否有限制跨月字段
      if (
        Object.prototype.hasOwnProperty.call(
          this.filter.value.field,
          "not_cross_month"
        ) &&
        this.filter.value.field.not_cross_month
      ) {
        const startMonth = e[0].split("-")[1];
        const endMonth = e[1].split("-")[1];
        // 月份不同提示
        if (startMonth !== endMonth) {
          this.$message.e("生成凭证的日期，不能跨月。");
          this.filter.value.value = null;
          return;
        }
      }
      const data = {
        type: "datepicker",
        name: this.filter.name,
        as: this.filter.as,
        field: this.filter.value.field.value,
        value: e || [],
      };
      this.$emit("change", data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/OperateTaskFormItem.vue